import {
  SIGN_UP_REQUEST,
  SIGN_UP_REQUEST_SUCCESS,
  SIGN_UP_REQUEST_FAILURE,
  SIGN_UP_RESET,
  CHECK_TOKEN,
  CHECK_TOKEN_FAILURE,
  CHECK_TOKEN_SUCCESS,
  FROM_ADVERTISE,
  CLEAR_ADVERTISE_INFO,
  UPDATE_FIRST_LOGIN_REQUEST,
  UPDATE_FIRST_LOGIN_SUCCESS,
  UPDATE_FIRST_LOGIN_FAILURE,
  SIGN_UP_ERROR_RESET,
} from "../../modules/constants";
import { createNotification } from "../../modules/notificationManager";
import { clearAdvertiseInfo, fromGoogleAd } from "./signUpActions";

// ------------------------------------
// Action handler methods
// ------------------------------------
export const signUpRequestHandler = (state, action) => {
  return {
    ...state,
    isLoading: true,
    errorMessage: "",
  };
};

export const signUpRequestSuccessHandler = (state, action) => {
  const {
    payload: { data },
  } = action;
  if (data.status === 201) {
    // if (data.data.is_first_login !== undefined) {
      localStorage.setItem("is_first_login", "true".toString());
    // }
    return {
      ...state,
      isLoading: false,
      redirect: true,
      token: data.data.token,
      userData: data.data,
    };
  }
  return {
    ...state,
    isLoading: false,
  };
};

export const signUpRequestFailureHandler = (state, action) => {
  if (action.payload.response === undefined) {
    return {
      ...state,
      isLoading: false,
      redirect: false,
      errorMessage: "Network error. Please try again.",
    };
  }
  const {
    payload: {
      response: { data },
    },
  } = action;

  let errorMessage = "An error occurred. Please try again.";

  if (data.email !== undefined) {
    errorMessage = data.email[0];
    // createNotification("error", data.email[0], 3000);
  } else if (data.username !== undefined) {
    errorMessage = data.username[0];
    // createNotification("error", data.username[0], 3000);
  } else if (data.turnstile_token !== undefined) {
    errorMessage = data.turnstile_token[0];
    // createNotification("error", data.turnstile_token[0], 3000);
  } else if (data.key !== undefined) {
    errorMessage = data.key[0];
    // createNotification("error", data.key[0], 3000);
  }

  return {
    ...state,
    isLoading: false,
    redirect: false,
    errorMessage,
  };
};

export const signUpResetHandler = (state, action) => {
  return {
    ...state,
    isLoading: false,
    redirect: false,
    token: null,
    userData: null,
    errorMessage: "",
  };
};

export const signUpErrorResetHandler = (state, action) => {
  return {
    ...state,
    errorMessage: "",
  };
};

export const checkTokenRequestHandler = (state, action) => {
  return {
    ...state,
  };
};

export const checkTokenRequestSuccessHandler = (state, action) => {
  return {
    ...state,
    isLoading: false,
  };
};

export const checkTokenRequestFailureHandler = (state, action) => {
  return {
    ...state,
    isLoading: false,
    redirect: false,
  };
};

export const fromAdvertiseHandler = (state, action) => {
  const {
    payload: { advertise },
  } = action;
  return {
    ...state,
    advertise: advertise,
  };
};

export const clearAdvertiseInfoHandler = (state, action) => {
  return {
    ...state,
    advertise: "",
  };
};

export const updateFirstLoginRequestHandler = (state, action) => {
  return {
    ...state,
    isLoadingFirstLogin: true,
  };
};

export const updateFirstLoginSuccessHandler = (state, action) => {
  return {
    ...state,
    isLoadingFirstLogin: false,
  };
};

export const updateFirstLoginFailureHandler = (state, action) => {
  return {
    ...state,
    isLoadingFirstLogin: false,
  };
};

// Action Handlers
const ACTION_HANDLERS = {
  [SIGN_UP_REQUEST]: signUpRequestHandler,
  [SIGN_UP_REQUEST_SUCCESS]: signUpRequestSuccessHandler,
  [SIGN_UP_REQUEST_FAILURE]: signUpRequestFailureHandler,

  [SIGN_UP_RESET]: signUpResetHandler,

  [SIGN_UP_ERROR_RESET]: signUpErrorResetHandler,

  [CHECK_TOKEN]: checkTokenRequestHandler,
  [CHECK_TOKEN_SUCCESS]: checkTokenRequestSuccessHandler,
  [CHECK_TOKEN_FAILURE]: checkTokenRequestFailureHandler,

  [FROM_ADVERTISE]: fromAdvertiseHandler,
  [CLEAR_ADVERTISE_INFO]: clearAdvertiseInfoHandler,

  [UPDATE_FIRST_LOGIN_REQUEST]: updateFirstLoginRequestHandler,
  [UPDATE_FIRST_LOGIN_SUCCESS]: updateFirstLoginSuccessHandler,
  [UPDATE_FIRST_LOGIN_FAILURE]: updateFirstLoginFailureHandler,
};

// default initial state
const initialState = {
  isLoading: false,
  redirect: false,
  token: null,
  userData: null,
  advertise: "",
  isLoadingFirstLogin: false,
  errorMessage: "",
};

export default function signUpReducer(state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type];

  return handler ? handler(state, action) : state;
}
